import { render } from "./5Questionnaire1.vue?vue&type=template&id=1cf710a5"
import script from "./5Questionnaire1.vue?vue&type=script&lang=js"
export * from "./5Questionnaire1.vue?vue&type=script&lang=js"

import "./5Questionnaire1.vue?vue&type=style&index=0&id=1cf710a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__